import React, { useState, useEffect, useCallback } from "react";
import { useApi } from "../../api/useApi";
import { FormControl, Label } from "../../components/Form/FormControls";
import { useSearch } from "../../Hooks/useSearch";
import { allIssues } from "../../api/issuesQueries";
import SearchSelect from "../../components/Forms/Search/SearchSelect";

const SearchIssues = ({ selectTopFilter, filterSource }) => {
  const [stateIssues, setStateIssues] = useState();

  const [{ errors, loading, data }, doFetch] = useApi();

  useEffect(() => {
    if (data) {
      const userOptions = data?.allIssues?.edges?.map((ug) => {
        const policy = ug?.node;
        return {
          label: policy?.name,
          value: policy?.id,
        };
      });

      setStateIssues(userOptions);
    }
  }, [data]);

  const onSearch = useCallback(
    (text) => {
      if (text) {
        const baseWhere = {
          or: [{ name: { contains: text } }],
        };

        if (filterSource) {
          baseWhere.sourceId = { eq: filterSource };
        }

        doFetch({
          query: allIssues,
          variables: {
            where: baseWhere,
            order: [{ name: "ASC" }],
          },
        });
      }
    },
    [doFetch]
  );

  const { inputText, handleInputChange, tooShortWarning } = useSearch({
    onSearch,
  });

  return (
    <div style={{ marginTop: "1rem" }}>
      <FormControl style={{ marginRight: "1rem" }}>
        <SearchSelect
          menuPlacement="auto"
          menuPortalTarget={document.body}
          label="Search Policies"
          placeholder="Search Policies"
          options={stateIssues}
          onChange={(e) => selectTopFilter({ value: "ById", id: e?.value })}
          inputValue={inputText}
          onInputChange={handleInputChange}
          loading={loading}
          error={errors}
          warning={tooShortWarning}
        />
      </FormControl>
    </div>
  );
};

export default SearchIssues;
